/*
 * @Auther: 罗耀祖
 * @Date: 2021-09-17 15:15:32
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-09-17 15:17:35
 * @name: 订单模块api
 * @Description: 订单模块api
 * @FilePath: \preSaleNafterSaleBackstage\src\api\order\order.api.js
 * @Author: desktop
 */
import apiAdd from "../apiAdd.js";
import apiEdit from "../apiEdit.js";
import apiDelete from "../apiDelete.js";
import apiSearch from "../apiSearch.js";
import axios from 'axios';
import { Message } from "element-ui";

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 订单列表
 * @param {Object} data -> {search{String}: 关键字, status{String}: 订单状态, limit: 每页数量， page: 页码}
 */
 export const orderGetList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/order/getList.html', data, instance);
}